import React, { useContext } from "react";
import { InputContext } from "../../../shared/contexts/InputContext";
import { OutputContext } from "../../../shared/contexts/OutputContext";
import { BENEFIT_TYPE_DETAILS } from "../../../assests/data/results-header-text";
import Modal from "../../general/Modal";
import ComparisonTable from "./ComparisonTable";
import classes from "./ComparisonModal.module.css";

const ComparisonModal = ({ isOpen, benefitType='earnings', onClose }) => {
  let label, suffix, colour;

  const { inputs } = useContext(InputContext);
  const { outputs, loading } = useContext(OutputContext);

  const filterDates = [
    inputs.memberInfo.dateOfPartRet,
    inputs.memberInfo.dateOfFullRet,
  ];
  const filterTypes = [benefitType];

  const filteredData = outputs.filter(
    (item) =>
      filterDates.includes(item.date) && filterTypes.includes(item.benefitType)
  );

  if (benefitType) {
    ({ label, suffix, colour } = BENEFIT_TYPE_DETAILS[benefitType]);
  }

  if (!isOpen) return null;

  return (
    <Modal modalHandler={onClose} allowClose = {true} buttonText = {"Close this window"}>
      <div className={classes.comparison_modal} >
        <h1>{label} Comparison</h1>
        <p>The following table sets out the {label} under each McCloud choice at both partial and full retirement</p>
        
        
        <ComparisonTable data={filteredData} />
      </div>
    </Modal>
  );
};

export default ComparisonModal;
